import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

// One level up in the site's structure: /work/:id → /work,
// /side-projects/book-cover → /side-projects, any top-level page → Home.
const getParentPath = (pathname) => {
  const segments = pathname.split('/').filter(Boolean);
  return segments.length > 1 ? `/${segments.slice(0, -1).join('/')}` : '/';
};

// Goes back to wherever the visitor came from on this site. React Router
// stores each entry's position in history.state.idx (0 = first page of the
// visit), so idx > 0 means the previous entry is one of ours. On a direct
// landing (e.g. a case study opened from LinkedIn) there's nothing of ours to
// go back to, so it falls back to the parent page — with `replace`, so idx
// stays 0 and repeated presses keep climbing (case study → Projects → Home)
// instead of bouncing between two pages or leaving the site. Still a real
// link to the parent, so modified clicks (new tab/window) work.
const BackButton = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const parentPath = getParentPath(pathname);

  const handleClick = (e) => {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    if ((window.history.state?.idx ?? 0) > 0) {
      navigate(-1);
    } else {
      navigate(parentPath, { replace: true });
    }
  };

  return (
    <Link to={parentPath} onClick={handleClick} className="cs-back-link">
      <span className="cs-back-chevron">‹</span> Back
    </Link>
  );
};

export default BackButton;
